import React from 'react';
import { EditableInfo } from '@icoach/components';

const BatchPaymentMemoBox = ({ className, batchPaymentMemo, onEdit }) => {
    return (
        <EditableInfo label="批次扣款備註" onEdit={onEdit} className={className} isMultiline>
            {batchPaymentMemo}
        </EditableInfo>
    );
};

export default BatchPaymentMemoBox;
